import axios from '@/utils/request'

export default {

    // 2020-11-03
    findByWorkerOrderId(workOrderId) {
        return axios.get('/mes/shipments/find-by-work-order-id/' + workOrderId);
    },
    // 2020-12-23
    findByWorkerOrderId(workOrderId) {
        return axios.get('/mes/shipments/find-by-work-order-id/' + workOrderId);
    }

    // //2020-11-03
    // create(params) {
    //     return axios.post('/mes/shipments', params);
    // },
    // //2020-11-04
    // create(params) {
    //     return axios.post('/mes/shipments/', params);
    // },
    // // 05-22
    // changeSpecsReceive(params) {
    //     return axios.post('/mes/shipments/change-specs-receive', params);
    // }

}

